<header class="header">
  <div class="header-content">
    <div class="logo">
      <a [routerLink]="['']">
        <img src="assets/images/logo.png" alt="Herbs.LYF Logo">
      </a>
    </div>

    <nav class="nav" [class.active]="isMenuOpen">
      <button class="closebtn" (click)="toggleMenu()"><i class="fa fa-close"></i></button>
      <ul class="nav-list">
        <li class="nav-item">
          <a [routerLink]="['']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['about-us']" routerLinkActive="active">About Us</a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['shop']" routerLinkActive="active">Shop</a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['contact-us']" routerLinkActive="active">Contact Us</a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['gallery']" routerLinkActive="active">Gallery</a>
        </li>
      </ul>
    </nav>

    <div class="header-right">
      <div class="cart">
        <a [routerLink]="[]" (click)="toggleCart()">
          <span class="cart-icon">
            <!-- SVG ICON -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
          </span>
          <span class="cart-count">{{count}}</span>
        </a>
      </div>

      <div class="login" (click)="checkOpenSignIn()">
        <a [routerLink]="[]">
          <span class="login-icon">
            <img src="assets/images/avtar.jpg" alt="avtar.jpg">
          </span>
        </a>
      </div>

      <div class="cart-drawer-overlay" *ngIf="isMenuOpen" (click)="toggleMenu()"></div>
      <div class="mobile-menu-toggle" (click)="toggleMenu()">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>

  <app-cart></app-cart>
</header>